module.exports = __webpack_public_path__ + "img/Skirt-Front-B6-Db-Fc-Ga-Hb-Ia-outside.4f5e96e4.png";